import { TableButtonCellValue, TableCellComponentProps } from '@/shared/types/table';
import { cn } from '@/shared/utils/cn';
import { Button } from '@/modules/Button';
import {
  getTableCellClasses,
  getTableCellProps,
  handleCellClick,
  getContentAlignClass,
  isFlexColumn,
} from '../../utils/cellStyles';

export const ButtonCell = ({
  value,
  row,
  column,
  state = 'default',
  className,
  onCellFocus,
  stickyLeft = 0,
  isLastLocked = false,
  isRowEditing,
  hasColumnMaxWidthAuto = false,
}: TableCellComponentProps) => {
  const baseClasses = getTableCellClasses(
    state,
    className,
    column.locked,
    isLastLocked,
    undefined,
    isRowEditing,
    false,
    column.width !== undefined || isFlexColumn(column, hasColumnMaxWidthAuto)
  );
  const cellProps = getTableCellProps(column, stickyLeft, undefined, false, hasColumnMaxWidthAuto);

  // Alineamiento del contenido
  const alignClass = getContentAlignClass(column.contentAlign);

  const buttonConfig: TableButtonCellValue | null =
    value && typeof value === 'object' && !Array.isArray(value)
      ? (value as TableButtonCellValue)
      : value !== null && value !== undefined
        ? { label: value as string | number }
        : null;

  const hasFixedWidth = column.width !== undefined;
  return (
    <td className={baseClasses} {...cellProps} onClick={(e) => handleCellClick(e, onCellFocus)}>
      <div
        className={cn(
          'ui-flex ui-h-full ui-items-center',
          alignClass,
          hasFixedWidth && 'ui-min-w-0 ui-overflow-hidden'
        )}
      >
        {buttonConfig && (
          <Button
            theme={buttonConfig.theme || 'solid'}
            color={buttonConfig.color || 'primary'}
            variant={buttonConfig.variant}
            size="sm"
            icon={buttonConfig.icon}
            leftSlot={buttonConfig.leftSlot}
            rightSlot={buttonConfig.rightSlot}
            colorIcon={buttonConfig.colorIcon}
            tooltip={buttonConfig.tooltip}
            onClick={() => buttonConfig.onClick?.(row)}
            disabled={buttonConfig.disabled || state === 'disabled'}
          >
            {buttonConfig.label}
          </Button>
        )}
      </div>
    </td>
  );
};
